import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Mobile-only single quick-action bar. One clear primary CTA — no noise.
// Hidden on /book and /admin to avoid duplicating in-page actions.
export default function MobileStickyCta() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/book") || pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-30 border-t border-stone-700 bg-stone-950/95 backdrop-blur-md"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 0.5rem)" }}
    >
      <div className="p-3">
        <Link
          to="/book"
          data-testid="mobile-cta-quote"
          className="w-full inline-flex items-center justify-center gap-2 bg-yellow-500 text-yellow-950 border-2 border-yellow-500 font-bold uppercase tracking-wider text-xs py-3.5"
        >
          Get a Free Estimate <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
